
export default class DateService {
    static getDaysOfWeek() {
        return ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
    }

    static getDayOfWeek(dayIndex) {
        const days = DateService.getDaysOfWeek();
        return days[dayIndex];
    }

    // Obtenir les mois de l'année en français
    static getMonths() {
        return [
            "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
            "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
        ];
    }

    static getMonth(monthIndex) {
        const months = DateService.getMonths();
        return months[monthIndex];
    }


    // Formater une date avec heure
    static formatDate(date = null) {
        const d = date ? new Date(date) : new Date();

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} à ${hours}:${minutes}`; // "DD/MM/YYYY à HH:mm"
    }

    // Formater une date sans l'heure
    static formatFrenchDateWithoutTime(date = null) {
        const dte = date ? new Date(date) : false;
        if (dte === false) {
            return null;
        }

        const year = dte.getFullYear();
        const month = String(dte.getMonth() + 1).padStart(2, '0');
        const day = String(dte.getDate()).padStart(2, '0');

        return `${day}/${month}/${year}`; // "DD/MM/YYYY"
    }

    // Formater une date sans l'heure
    static formatDateWithoutTime(date = null) {
        const d = date ? new Date(date) : new Date();

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`; // "YYYY-MM-DD"
    }


    // Formater une date sans l'heure
    static formatDateFull(date) {
        const d = date ? new Date(date) : new Date();

        // Jour, mois, année, heure et minute
        const dayOfWeek = DateService.getDayOfWeek(d.getDay());
        const day = String(d.getDate()).padStart(2, '0');
        const month = DateService.getMonth(d.getMonth());
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');

        return `${dayOfWeek} ${day} ${month} ${year} à ${hours}h${minutes}`; // "jour DD mois YYYY à HHhmm"
    }

    static formatDateWithSeconds(date = null) {
        const d = date ? new Date(date) : new Date();

        const dayOfWeek = DateService.getDayOfWeek(d.getDay());
        const day = String(d.getDate()).padStart(2, '0');
        const month = DateService.getMonth(d.getMonth());
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');

        return `${dayOfWeek} ${day} ${month} ${year} à ${hours}h${minutes}m${seconds}s`;
    }

    static formatDateWithDuration = (date, duree) => {
        const d = new Date(date);
        const optionsDate = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
        const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: false };
        const formattedDate = d.toLocaleDateString('fr-FR', optionsDate);
        const formattedTimeStart = d.toLocaleTimeString('fr-FR', optionsTime).replace(':', 'h');
        d.setMinutes(d.getMinutes() + duree);
        const formattedTimeEnd = d.toLocaleTimeString('fr-FR', optionsTime).replace(':', 'h');
        return `${formattedDate} de ${formattedTimeStart} à ${formattedTimeEnd}`;
    };

    static formatDateJoli = (date) => {
        const d = new Date(date);
        const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
        return d.toLocaleDateString('fr-FR', options);
    };


    // Comparer deux dates (même jour)
    static sameDay(date1, date2) {
        const d1 = new Date(date1);
        const d2 = new Date(date2);
        return d1.getDate() === d2.getDate() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getFullYear() === d2.getFullYear();
    }

    // Obtenir le jour du mois à partir d'une date
    static getDayOfMonth(date) {
        const d = new Date(date);
        const day = d.getDate();
        return String(day).padStart(2, '0');
    }

    // Ajouter des minutes au début de la journée
    static addMinutesToStartOfDay(date, minutes) {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        d.setMinutes(d.getMinutes() + minutes);

        const hours = String(d.getHours()).padStart(2, '0');
        const minutesFormatted = String(d.getMinutes()).padStart(2, '0');

        return `${hours}:${minutesFormatted}`;
    }

    // Obtenir le début du mois précédent
    static getStartOfPreviousMonth() {
        const now = new Date();
        now.setMonth(now.getMonth() - 1);
        now.setDate(1);
        return now.toISOString().split('T')[0];  // YYYY-MM-DD
    }

    // Obtenir la fin du mois précédent
    static getEndOfPreviousMonth() {
        const now = new Date();
        now.setMonth(now.getMonth(), 0);
        return now.toISOString().split('T')[0]; // YYYY-MM-DD
    }

    // Soustraire des mois à une date
    static subtractMonths(months, date = null) {
        if (!date) {
            date = new Date();
        }
        date.setMonth(date.getMonth() - months);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`; // "YYYY-MM-DD"
    }

    // Obtenir le mois précédent à partir de la date actuelle
    static getPreviousMonth(date = null) {
        if (!date) {
            date = new Date();
        }
        date.setMonth(date.getMonth() - 1);
        return DateService.getMonths()[date.getMonth()];
    }

    // obtenir la date du premier jour du mois
    static getStartOfMonth(year, monthIndex) {
        const startDate = new Date(year, monthIndex, 1);
        return startDate.toISOString().split('T')[0]; //  YYYY-MM-DD
    }

    // obtenir la date du dernier jour du mois
    static getEndOfMonth(year, monthIndex) {
        const endDate = new Date(year, monthIndex + 1, 0);
        return endDate.toISOString().split('T')[0]; // YYYY-MM-DD
    }

    static isValidDate(value) {
        const date = new Date(value);
        return !isNaN(date.getTime());
    }

    static isValidISODate(d) {
        const iso8601Regex = /^\d{4}-\d{2}-\d{2}T(\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|([+-]\d{2}:\d{2})))?$/;
        if (iso8601Regex.test(d)) {
            const date = new Date(d);
            return !isNaN(date.getTime());
        }
        return false;
    }

    static isValidUniversalDate(d) {
        const iso8601Regex = /^\d{4}-\d{2}-\d{2}$/;
        if (iso8601Regex.test(d)) {
            const [year, month, day] = d.split('-').map(Number);
            const date = new Date(year, month - 1, day);
            return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
        }
        return false;
    }

    static fromNow(date) {
        const now = new Date();
        const targetDate = new Date(date);
        const diffInSeconds = Math.floor((now - targetDate) / 1000);

        const rtf = new Intl.RelativeTimeFormat('fr', { numeric: 'auto' });

        if (diffInSeconds < 60) {
            return rtf.format(-diffInSeconds, 'second');
        }

        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) {
            return rtf.format(-diffInMinutes, 'minute');
        }

        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) {
            return rtf.format(-diffInHours, 'hour');
        }

        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 30) {
            return rtf.format(-diffInDays, 'day');
        }

        const diffInMonths = Math.floor(diffInDays / 30);
        if (diffInMonths < 12) {
            return rtf.format(-diffInMonths, 'month');
        }

        const diffInYears = Math.floor(diffInMonths / 12);
        return rtf.format(-diffInYears, 'year');
    };

    static convertFrenchDateToIso(frenchDateTime) {
        let frenchDate = frenchDateTime;
        let frenchTime = null;

        if (frenchDateTime.includes("à")) {
            const frenchDateArr = frenchDateTime.split("à");
            frenchDate = frenchDateArr[0].trim();
            frenchTime = frenchDateArr[1].trim();
        }

        const parts = frenchDate.split('/');
        if (parts.length !== 3) {
            throw new Error("Format de date invalide");
        }

        const day = parts[0].padStart(2, '0');
        const month = parts[1].padStart(2, '0');
        const year = parts[2];

        if (frenchTime) {
            let hours, minutes;
            if (frenchTime.includes('h')) {
                const timeParts = frenchTime.split('h');
                hours = timeParts[0].trim().padStart(2, '0');
                minutes = timeParts[1].trim() || '00';
                minutes = minutes.padStart(2, '0');
            } else {
                const timeParts = frenchTime.split(':');
                hours = timeParts[0].trim().padStart(2, '0');
                minutes = (timeParts[1] || '00').trim().padStart(2, '0');
            }

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        }

        return `${year}-${month}-${day}`; // "YYYY-MM-DD"
    }

    // Format for datetime-local
    static formatDateForInput(date) {
        const d = new Date(date);
        // Si invalid date return null
        if (isNaN(d.getTime())) {
            return null;
        }

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = d.getDate();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');

        // Prendre en compte le 0 avant le jour
        const formattedDay = String(day).padStart(2, '0');
        const formattedMonth = String(month).padStart(2, '0');
        return `${year}-${formattedMonth}-${formattedDay}T${hours}:${minutes}`;
    }
}

